// React
import React, { useState } from "react";
// React
// CSS
import styles from "./QuizMaker.module.css";
// CSS
// Models
// Models
// Utils
// Utils
// Components
import QuizCreator from "./QuizCreator/QuizCreator";
import FullQuizCreator from "./FullQuizCreator/FullQuizCreator";
import { quiz_maker_back1 } from "../../Images/images";
// Components

const QuizMaker = () => {
  // States
  //
  const [currentQuizType, setCurrentQuizType] = useState<"creator" | "full">(
    "creator"
  );
  // States

  return (
    <div
      className={`${styles.quizMakerContainer} flex flex-col items-center justify-between dark:!text-black`}
    >
      <div className={`${styles.topItems} w-full`}>
        <div
          className={`${styles.currentQuizTypeContainer} relative w-full flex flex-row items-center justify-between pt-2 dark:!text-black  bg-white`}
        >
          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          <div
            className={`${styles.littleAbsoluteItem} absolute w-1/2 h-1 bottom-0 transition-all dark:!text-black`}
            style={{
              background:
                currentQuizType === "full"
                  ? "rgb(0 , 150, 136)"
                  : "rgb(126 ,58 ,229)",
              left: currentQuizType === "full" ? "50%" : "0",
            }}
          ></div>
          {/*  */}
          {/*  */}
          <button
            className={`${styles.selectorBtn} text-center w-1/2 h-full py-2 pb-4 flex items-center justify-center dark:!text-black`}
            style={{
              color: "rgb(126, 58, 229) ",
              borderLeft: "1px solid rgb(240, 240, 240)",
            }}
            onClick={() => {
              setCurrentQuizType("creator");
            }}
          >
            دفترچه‌های کنکور با پاسخنامه تشریحی
          </button>
          <button
            className={`${styles.selectorBtn} text-center w-1/2`}
            style={{ color: "rgb(0 , 150, 136) " }}
            onClick={() => {
              setCurrentQuizType("full");
            }}
          >
            نمونه سوالات امتحانی
          </button>
        </div>
        <div
          className={`${styles.questionCreationFormContainer} ${
            currentQuizType === "creator" ? "mt-10" : ""
          }`}
        >
          {currentQuizType === "creator" && <QuizCreator />}
          {currentQuizType === "full" && <FullQuizCreator />}
        </div>
      </div>
      {currentQuizType === "creator" ? (
        <img
          src={quiz_maker_back1}
          alt=""
          className="w-10/12 h-1/4 mb-5  object-contain"
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default QuizMaker;
